module.exports = __webpack_public_path__ + "static/media/logo2.1fe92616.jpg";